module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/buyer-consultancy-small.c220fa468eb557d7e8297a06c4d85de2.jpg";